import { Certificate } from "../types";
import { postServiceCall } from "./base";
import store from "../store";
import { RawTransaction } from "../types/transactions_query";

export interface EuroshellCertificateListResult {
  certificates: Certificate[];
}

export async function getEuroshellCertificateList(from: string, to: string): Promise<EuroshellCertificateListResult> {
  return await postServiceCall("euroshellCertificatesList", { from, to, language: store.state.lang.key });
}

export interface EuroshellCertificateResult {
  date: string;
  txns: { transactions: RawTransaction[] };
}

export async function saveEuroshellCertificate(data: Certificate): Promise<EuroshellCertificateResult> {
  return await postServiceCall("euroshellCertificates", data);
}
